import * as React from 'react';
import { getIntentClassName } from 'vet-bones/utils';

import { InvalidMappingsWarning } from 'src/components/InvalidMappingsWarning';
import { withConfirmation } from 'src/components/withConfirmation';
import { Mapping } from 'src/containers/ProjectDiagram/types/data';
import {
  ProjectFileUpload,
  ProjectVirtualGraph,
} from 'src/store/state/projects';
import * as copy from 'src/templates/copy';

export const confirmAcceptInvalidMappings = async ({
  fileUploadsById,
  virtualGraphsById,
  invalidMappingsByResource,
  labelsByIri,
}: {
  fileUploadsById: Record<string, ProjectFileUpload>;
  virtualGraphsById: Record<string, ProjectVirtualGraph>;
  invalidMappingsByResource: Record<
    string,
    Array<Mapping & { relationshipIri?: string }>
  >;
  labelsByIri: Record<string, string>;
}) => {
  return new Promise<boolean>((resolve) => {
    const hasInvalidMappings = Object.values(invalidMappingsByResource).some(
      (mappings) => mappings.length
    );
    if (!hasInvalidMappings) {
      resolve(true);
      return;
    }

    withConfirmation({
      dialogClassName: 'sd-dialog-invalid-mappings',
      message: (
        <InvalidMappingsWarning
          fileUploadsById={fileUploadsById}
          labelsByIri={labelsByIri}
          mappingsByResource={invalidMappingsByResource}
          virtualGraphsById={virtualGraphsById}
        />
      ),
      noPrompt: copy.components.invalidMappings.dialog.cancel,
      title: copy.components.invalidMappings.dialog.title,
      yesButtonClassName: getIntentClassName('sd-green'),
      yesPrompt: copy.components.invalidMappings.dialog.proceed,
      onConfirmationSuccess: () => resolve(true),
      onConfirmationFailure: () => resolve(false),
    });
  });
};
